exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-box[data-v-a0f40dda] {\n  display: inline-block;\n  border: 1px dashed #c0ccda;\n  border-radius: 6px;\n  height: 107px;\n  width: 308px;\n  cursor: pointer;\n  overflow: hidden;\n}\n.setting_pic[data-v-a0f40dda] {\n  height: 107px;\n  width: 308px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-a0f40dda","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/member/bargain/index.vue
// module id = 1653
// module chunks = 0